import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";

// Import components
import ContactForm from "../components/contactForm";
import Navigation from "../components/navigation";

// Import styles
import "bootstrap/dist/css/bootstrap.min.css";
import "../base.scss";
import "../assets/fonts/fonts.css";
import "../variables.scss";
import "./styles/main.scss";

// Import icons
import { AiFillFacebook } from "@react-icons/all-files/ai/AiFillFacebook";
import { AiFillInstagram } from "@react-icons/all-files/ai/AiFillInstagram";
import { AiFillYoutube } from "@react-icons/all-files/ai/AiFillYoutube";

// Bootstrap imports
import { Container } from "react-bootstrap";

const Main = ({ children }) => {
  let nav = (
    <ul className="nav">
      <li>
        <Link
          activeClassName="footer-active"
          partiallyActive={true}
          to="/about"
        >
          Who We Are
        </Link>
      </li>
      <li>
        <Link
          activeClassName="footer-active"
          partiallyActive={true}
          to="/projects"
        >
          Our Work
        </Link>
      </li>
      <li>
        <Link activeClassName="footer-active" to="/services">
          What We Do
        </Link>
      </li>
      <li>
        <Link activeClassName="footer-active" partiallyActive={true} to="/blog">
          Our Blog
        </Link>
      </li>
      <li>
        <Link activeClassName="footer-active" to="/contact">
          Contact
        </Link>
      </li>
    </ul>
  );

  let social = (
    <ul className="social">
      <li>
        <a
          href="https://www.facebook.com/mountaincraftproductions/"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="This is an external link (opens in a new tab)"
        >
          <AiFillFacebook />
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/mtncraft/"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="This is an external link (opens in a new tab)"
        >
          <AiFillInstagram />
        </a>
      </li>
      <li>
        <a
          href="https://www.youtube.com/channel/UCxzxq9wy82dQJhUTUZTsvJw"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="This is an external link (opens in a new tab)"
        >
          <AiFillYoutube />
        </a>
      </li>
    </ul>
  );

  return (
    <>
      <header>
        <Navigation />
      </header>
      <main>{children}</main>
      <footer>
        <ContactForm />
        <Container>
          <div className="logo">
            <StaticImage
              src="../assets/images/footer-logo.png"
              alt="The Mtn Craft logo linking page to the homepage."
            />
          </div>
          {nav}
          {social}
        </Container>
        <Container>
          <div className="copyright">
            <h6 className="talk">
              © {new Date().getFullYear()} Mountain Craft Productions
              <br /> All Rights Reserved
            </h6>
          </div>
        </Container>
      </footer>
    </>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Main;
